module.exports = __webpack_public_path__ + "media/images/athletes/507-05ab15a1e05d7226d8932fb2f35d4ca5.png";